import AuswahlwerteController from "@/controller/AuswahlwerteController";
import { useLanguageStore } from "@/stores/language";
import { useAuswahlwerteStore } from "@/stores/vermittlungsportal/auswahlwerte";

let auswahlwerteStore: ReturnType<typeof useAuswahlwerteStore> | null = null;
function getAuswahlwerteStore() {
  if (!auswahlwerteStore) {
    auswahlwerteStore = useAuswahlwerteStore();
  }
  return auswahlwerteStore;
}

export default {
  async fetchAuswahlwerte() {
    const auswahlwerteStore = getAuswahlwerteStore();
    const languageStore = useLanguageStore();

    auswahlwerteStore.loading = true;
    auswahlwerteStore.error = null;

    try {
      const data = await AuswahlwerteController.getAuswahlwerte(
        languageStore.currentLangId
      );

      // Assign the fetched data to the state
      auswahlwerteStore.betriebszweige = data.betriebszweige || [];
      auswahlwerteStore.bewirtschaftungsarten =
        data.bewirtschaftungsarten || [];
      auswahlwerteStore.hoflage = data.hoflage || [];
      auswahlwerteStore.nebenbetriebe = data.nebenbetriebe || [];
      auswahlwerteStore.tiere = data.tiere || [];
      auswahlwerteStore.vermittlungsstellen = data.vermittlungsstellen || [];
      auswahlwerteStore.geschlechter = data.geschlechter || [];
      auswahlwerteStore.sprachen = data.sprachen || [];
      auswahlwerteStore.subventionskantone = data.subventionskantone || [];
      auswahlwerteStore.laender = data.laender || [];
      auswahlwerteStore.laenderAll = data.laenderAll || [];
      auswahlwerteStore.ernaehrungsformen = data.ernaehrungsformen || [];
      auswahlwerteStore.sprachkenntnisse = data.sprachkenntnisse || [];
      auswahlwerteStore.partnerschulen = data.partnerschulen || [];
      auswahlwerteStore.aufenthaltsbewilligungstypen =
        data.aufenthaltsbewilligungstypen || [];
      auswahlwerteStore.einsatzbereiche = data.einsatzbereiche || [];
      auswahlwerteStore.angebotstati = data.angebotsstati || [];
      auswahlwerteStore.belegungsstati = data.belegungsstati || [];
      auswahlwerteStore.sanitaereeinrichtungen =
        data.sanitaereeinrichtungen || [];
      auswahlwerteStore.einsatzorte = data.einsatzorte || [];
      auswahlwerteStore.einsatzherkunftJugendliche = data.einsatzherkunftJugendliche || [];

      // Update available languages in language store
      languageStore.setAvailableLanguages(auswahlwerteStore.sprachen || []);
    } catch (error) {
      auswahlwerteStore.error = "Failed to fetch auswahlwerte";
      console.error(error);
    } finally {
      auswahlwerteStore.loading = false;
    }
  },
};
